module.exports = __webpack_public_path__ + "static/media/Account_Type_Business.1261fe7a.svg";